import { useRef } from "react";
import "./ClothingBestDeal.css";
import { Link } from "react-router-dom";

const ClothingBestDeal = ({
  products = [],
  title = "Best Deal of Fashion",
}) => {
  const scrollRef = useRef(null);

  // const scrollLeft = () => {
  //   scrollRef.current?.scrollBy({ left: -300, behavior: "smooth" });
  // };

  // const scrollRight = () => {
  //   scrollRef.current?.scrollBy({ left: 300, behavior: "smooth" });
  // };

  return (
    <div className="container">
      <section className="bestdeal-section">
        {/* Title */}
        <h2 className="bestdeal-title">{title}</h2>

        {/* Scroll Wrapper — left arrow + scroll area + right arrow */}
        <div className="bestdeal-scroll-wrapper">
          <div className="bestdeal-scroll" ref={scrollRef}>
            {products.length === 0 ? (
              <p className="no-data">No products found</p>
            ) : (
              products.map((item) => (
                <Link to={"/clothing/" + item.id} key={item.id}>
                  <div className="bestdeal-card" key={item.id}>
                    <img src={item.image} alt={item.name} />
                    <div className="product-info">
                      <span className="price">{item.price}</span>
                      {item.oldPrice && (
                        <span className="old-price">{item.oldPrice}</span>
                      )}
                      {item.discount && (
                        <span className="discount">{item.discount}</span>
                      )}
                      <p className="product-name">{item.name}</p>
                    </div>
                  </div>
                </Link>
              ))
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ClothingBestDeal;
